import { ExtensionStorage } from './extension.storage';
import { LocalStorage } from './local.storage';

const isInIframe = window.self !== window.top;

export default isInIframe ? new ExtensionStorage() : new LocalStorage();
